import { ErrorAlert, SuccessAlert } from "@worthy-npm/clarity";
import React from "react";

const CertificateAlert = (props) => {
    const { variant, onClose } = props;

    const Alert = variant === "success" ? SuccessAlert : ErrorAlert;
    const text =
        variant === "success"
            ? "GIA certificate details successfully updated"
            : "Failed to update GIA certificate details";

    return (
        <div className="alerts-wrapper" style={{ marginBottom: "17px" }}>
            <Alert text={text} canClose onClose={onClose} />
        </div>
    );
};

export default CertificateAlert;
